<template>
  <div class="login-wrap">
    <van-nav-bar
      title="修改密码"
      fixed
      placeholder
      :z-index="10"
      left-arrow
      @click-left="onClickLeft"
    >
    </van-nav-bar>
    <div class="user-input block">
      <van-form @submit="loginFn" ref="loginForm">
        <div class="input-area">
          <div class="on-input">
            <img src="/images/login/phone@2x.png" alt="" />
            <van-field
              disabled
              v-model.trim="form.mobile"
              type="number"
              placeholder="请输入手机号"
              maxlength="11"
            />
          </div>
          <div class="on-input">
            <img src="/images/login/verification@2x.png" alt="" />
            <van-field
              v-if="isOldPassShow"
              v-bind:type="!isOldPassOpen ? 'password' : 'text'"
              v-model.trim="form.oldPassword"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="off"
              placeholder="请输入旧密码"
              maxlength="12"
              minlength="6"
              :right-icon="!isOldPassOpen ? 'closed-eye' : 'eye-o'"
              @click-right-icon="showPassword('isOldPassOpen')"
            />
          </div>
          <div class="on-input">
            <img src="/images/login/verification@2x.png" alt="" />
            <van-field
              :type="!isPassOpen ? 'password' : 'text'"
              v-model.trim="form.newPassword"
              placeholder="请输入新密码"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="off"
              maxlength="12"
              minlength="6"
              :right-icon="!isPassOpen ? 'closed-eye' : 'eye-o'"
              @click-right-icon="showPassword('isPassOpen')"
            />
          </div>
          <div class="on-input">
            <img src="/images/login/verification@2x.png" alt="" />
            <van-field
              :type="!isPass2Open ? 'password' : 'text'"
              v-model.trim="form.newPassword2"
              placeholder="请输入确认密码"
              autocomplete="new-password"
              autocorrect="off"
              autocapitalize="off"
              maxlength="12"
              minlength="6"
              :right-icon="!isPass2Open ? 'closed-eye' : 'eye-o'"
              @click-right-icon="showPassword('isPass2Open')"
            />
          </div>
          <div class="tips">
            温馨提示：密码长度6~12位,须包含数字、字母、符号最少2种以上元素
          </div>
          <van-button
            class="large-btn login-btn"
            size="large"
            :loading="loading"
            round
            color="linear-gradient(to right,#46C4FF, #1C97FF)"
            type="info"
            native-type="submit"
            >确认
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>
<script>
import Api from "@/api/user";
import { getUserInfo, PasswordReg, IsMobile } from "@/libs/utils";
import { Toast } from "vant";

export default {
  data() {
    return {
      loading: false,
      isOldPassShow: true,
      isOldPassOpen: false,
      isPassOpen: false,
      isPass2Open: false,
      form: {
        mobile: "",
        oldPassword: "",
        newPassword: "",
        newPassword2: "",
      },
      user: {},
    };
  },
  created() {
    this.user = getUserInfo();
    this.form.mobile = this.user.mobile;
  },
  methods: {
    async loginFn() {
      try {
        if (!this.form.mobile) throw "请输入手机号";
        if (!IsMobile.test(this.form.mobile)) throw "手机号格式不正确";
        if (!this.form.oldPassword) throw "请输入旧密码";
        if (!this.form.newPassword) throw "请输入新密码";
        if (!this.form.newPassword2) throw "请输入确认密码";
        if (this.form.newPassword !== this.form.newPassword2)
          throw "两次密码不一致";
        if (!PasswordReg.test(this.form.newPassword)) throw "密码格式不正确";
        this.loading = true;
        await Api.updateUserPassword(this.form);
        Toast.success("修改成功");
        this.$router.back();
      } catch (error) {
        Toast.fail(error);
      } finally {
        this.loading = false;
      }
    },
    showPassword(type) {
      this[type] = !this[type];
      this.$nextTick(() => {
        this.$forceUpdate(); // 强制更新组件
      });
    },
  },
};
</script>
<style lang="less" scoped>
.login-wrap {
  background: #ebf6ff;
  padding-bottom: 20px;
  overflow-x: hidden;
  overflow-y: auto;
  .tips {
    color: #999;
    line-height: 20px;
  }
  .user-input {
    margin-top: 16px;
    position: relative;
    padding-top: 20px;
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 10px;
      border-radius: 4px 4px 0 0;
      background: #1890ff;
      top: -4px;
      z-index: 0;
    }
    &::after {
      content: "";
      position: absolute;
      width: 100%;
      height: 10px;
      border-radius: 4px 4px 0 0;
      background: #fff;
      top: 0px;
      z-index: 0;
    }
    .title {
      height: 18px;
      font-size: 18px;
      font-weight: 600;
      color: #333333;
      line-height: 18px;
      text-align: center;
      margin-bottom: 20px;
    }
    .input-area {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 20px;
      .on-input {
        margin-bottom: 16px;
        background: #f6fbff;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
        border-radius: 24px;
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;
        overflow: hidden;
        padding: 0 16px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 12px;
        }
        .van-cell {
          padding: 0;
          background: #f6fbff;
          flex: 1;
          &::after {
            content: unset;
          }
        }
      }
      .login-btn {
        margin-top: 21px;
        width: 280px;
        height: 52px;
        margin-bottom: 16px;
        background: url("/images/login/button@2x.png") no-repeat !important;
        background-size: 100% 100% !important;
      }
    }
  }
}
</style>
